import { render, staticRenderFns } from "./HolderList.vue?vue&type=template&id=b454f1a0&scoped=true"
import script from "./HolderList.vue?vue&type=script&lang=js"
export * from "./HolderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b454f1a0",
  null
  
)

export default component.exports